/* Claw machines page (/pages/claw-machines). Map, "find my nearest", town buttons and scroll reveals.
   Ported from workspace/drafts/claw-locator/build3.py (direction A, approved 2026-10-07).
   Loaded by every claw-page-* section with defer, so it can appear several times: guarded to run once. */
(function () {
  if (window.__clawPage) return;
  window.__clawPage = true;

  const esc = s => String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const CHEV = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M7.5 3.75L13.75 10L7.5 16.25" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const dirs = v => 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(v.lat + ',' + v.lng);
  function km(a, b) {
    const R = 6371, r = x => x * Math.PI / 180, dLat = r(b.lat - a.lat), dLng = r(b.lng - a.lng);
    const h = Math.sin(dLat / 2) ** 2 + Math.cos(r(a.lat)) * Math.cos(r(b.lat)) * Math.sin(dLng / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  let map = null;
  function initFinder() {
    const root = document.getElementById('where');
    const el = document.getElementById('fd-map');
    const dataEl = document.getElementById('claw-venues');
    if (!root || !el || !dataEl) return;
    // Leaflet is deferred in the finder section, after this file: wait for it.
    if (!window.L) { if (document.readyState !== 'complete') window.addEventListener('load', initFinder, {once: true}); return; }
    if (map) { map.remove(); map = null; }
    const DATA = JSON.parse(dataEl.textContent);
    const updEl = document.getElementById('fd-updated');
    if (updEl && DATA.updated && root.dataset.updated) { updEl.textContent = root.dataset.updated + ' ' + DATA.updated; updEl.hidden = false; }
    const t = {
      label: root.dataset.label || 'Find my nearest claw',
      finding: root.dataset.finding || 'Finding you...',
      found: root.dataset.found || 'Your three nearest',
      miles: root.dataset.miles || 'miles away',
      denied: root.dataset.denied || "Location's switched off for this site. Type your town or postcode below instead.",
      unavailable: root.dataset.unavailable || "Couldn't pin you down. Type your town or postcode below instead.",
      searching: root.dataset.searching || 'Looking that up...',
      notfound: root.dataset.notfound || "We couldn't find that. Try a town like Belfast or a postcode like BT1 1AA.",
      apierror: root.dataset.apierror || "Our postcode lookup isn't answering right now. Try a town name like Belfast instead."
    };
    map = L.map(el, {scrollWheelZoom: false, zoomControl: false});
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {maxZoom: 19, attribution: '&copy; OpenStreetMap contributors'}).addTo(map);
    // 44px tap area around the same 26px pin; the anchor stays at the pin's base.
    const icon = L.divIcon({className: 'pinm-hit', html: '<div class="pinm"></div>', iconSize: [44, 44], iconAnchor: [22, 44], popupAnchor: [0, -24]});
    const markers = DATA.venues.map(v => L.marker([v.lat, v.lng], {icon, title: v.name}).addTo(map)
      .bindPopup('<b>' + esc(v.name) + '</b><br>' + esc(v.town) + '<br><a href="' + dirs(v) + '" target="_blank" rel="noopener">Directions</a>'));
    const fitAll = () => { if (!map) return; map.invalidateSize(); map.fitBounds(L.featureGroup(markers).getBounds(), {paddingTopLeft: [20, 20], paddingBottomRight: [20, 90], maxZoom: 12}); };
    fitAll();
    if (document.readyState !== 'complete') window.addEventListener('load', fitAll, {once: true});
    const cardsEl = document.getElementById('fd-cards');
    function cards(list) {
      cardsEl.innerHTML = list.map(({v, d}) => '<div class="fd__card"><h3>' + esc(v.name) + '</h3><p>' + esc([v.address, v.town].filter(Boolean).join(', ')) + '</p><p class="d">' + (d == null ? esc(v.played || '') : (d * 0.621371).toFixed(1) + ' ' + esc(t.miles)) + '</p><a href="' + dirs(v) + '" target="_blank" rel="noopener" aria-label="Directions">' + CHEV + '</a></div>').join('');
    }
    const msgEl = document.getElementById('fd-msg');
    const say = text => { if (!msgEl) return; msgEl.textContent = text || ''; msgEl.hidden = !text; };
    let meDot = null;
    // Three nearest venues to a point, as cards with distances, and fit the map to them.
    // town: a typed town key. Venues in that town show their "Played ..." label (as the town buttons do);
    // venues in other towns show miles from the typed town's centre.
    function showNearest(me, town) {
      const top = DATA.venues.map((v, i) => ({v, i, d: km(me, v)})).sort((a, b) => a.d - b.d).slice(0, 3);
      cards(town ? top.map(x => townKey(x.v.town) === town ? {v: x.v, i: x.i, d: null} : x) : top);
      if (meDot) meDot.remove();
      meDot = L.circleMarker([me.lat, me.lng], {radius: 8, color: '#000', weight: 2, fillColor: '#fff', fillOpacity: 1}).addTo(map);
      map.fitBounds(L.latLngBounds(top.map(x => [x.v.lat, x.v.lng]).concat([[me.lat, me.lng]])), {paddingTopLeft: [30, 30], paddingBottomRight: [30, 220]});
    }
    const go = document.getElementById('fd-go');
    if (go) go.addEventListener('click', () => {
      const lbl = go.firstElementChild;
      say('');
      const fail = text => { lbl.textContent = t.label; say(text); };
      if (!navigator.geolocation) { fail(t.unavailable); return; }
      lbl.textContent = t.finding;
      try {
        navigator.geolocation.getCurrentPosition(p => {
          showNearest({lat: p.coords.latitude, lng: p.coords.longitude});
          lbl.textContent = t.found;
        }, err => {
          fail(err && err.code === 1 ? t.denied : t.unavailable);
        }, {enableHighAccuracy: false, timeout: 10000, maximumAge: 300000});
      } catch (e) { fail(t.unavailable); }
    });

    // Typed fallback: a venue town, then a full UK postcode, then an outcode (postcodes.io).
    const norm = s => String(s).toLowerCase().replace(/[^a-z]/g, '');
    const ALIAS = {londonderry: 'derry'};
    const townKey = s => { const k = norm(s); return ALIAS[k] || k; };
    const FULL_PC = /^[A-Z]{1,2}[0-9][A-Z0-9]?[0-9][A-Z]{2}$/;
    const OUTCODE = /^[A-Z]{1,2}[0-9][A-Z0-9]?$/;
    async function lookup(path) {
      // null = not found; throws on network or service errors
      const r = await fetch('https://api.postcodes.io/' + path, {headers: {Accept: 'application/json'}});
      if (r.status === 404) return null;
      if (!r.ok) throw new Error('postcodes.io ' + r.status);
      const j = await r.json();
      const res = j && j.result;
      return res && typeof res.latitude === 'number' && typeof res.longitude === 'number' ? {lat: res.latitude, lng: res.longitude} : null;
    }
    async function resolve(q) {
      const k = townKey(q);
      if (k) {
        const inTown = DATA.venues.filter(v => townKey(v.town) === k);
        if (inTown.length) return {lat: inTown.reduce((a, v) => a + v.lat, 0) / inTown.length, lng: inTown.reduce((a, v) => a + v.lng, 0) / inTown.length, town: k};
      }
      const pc = String(q).toUpperCase().replace(/\s+/g, '');
      if (FULL_PC.test(pc)) return lookup('postcodes/' + encodeURIComponent(pc));
      if (OUTCODE.test(pc)) return lookup('outcodes/' + encodeURIComponent(pc));
      return null;
    }
    const form = document.getElementById('fd-form');
    const input = document.getElementById('fd-q');
    if (form && input) form.addEventListener('submit', async e => {
      e.preventDefault();
      const q = input.value.trim();
      if (!q) { input.focus(); return; }
      const btn = form.querySelector('button');
      if (btn) btn.disabled = true;
      say(t.searching);
      try {
        const at = await resolve(q);
        if (!at) { cardsEl.innerHTML = ''; say(t.notfound); return; }
        say('');
        showNearest(at, at.town);
        input.blur();
        el.scrollIntoView({behavior: 'smooth', block: 'start'});
      } catch (err) {
        cardsEl.innerHTML = '';
        say(t.apierror);
      } finally {
        if (btn) btn.disabled = false;
      }
    });
    document.querySelectorAll('#fd-chips button').forEach(b => b.addEventListener('click', () => {
      const list = DATA.venues.map((v, i) => ({v, i, d: null})).filter(x => x.v.town === b.dataset.t);
      if (!list.length) return;
      cards(list);
      map.fitBounds(L.latLngBounds(list.map(x => [x.v.lat, x.v.lng])), {paddingTopLeft: [40, 40], paddingBottomRight: [40, 220], maxZoom: 15});
      root.scrollIntoView({behavior: 'smooth'});
    }));
  }

  let io = null;
  function initReveal() {
    const els = document.querySelectorAll('.cz .reveal:not(.in)');
    if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) {
      els.forEach(el => el.classList.add('in'));
      return;
    }
    if (!io) io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), {threshold: .15});
    els.forEach(el => io.observe(el));
  }

  function init() { initFinder(); initReveal(); }
  // Deferred scripts run before DOMContentLoaded, and Leaflet (also deferred) comes after this file.
  if (document.readyState === 'complete') init(); else document.addEventListener('DOMContentLoaded', init, {once: true});
  document.addEventListener('shopify:section:load', init);
})();
